import { createContext, useContext } from 'react';

// @TODO biome-ignore lint/suspicious/noExplicitAny:
export const RasContextStore = createContext<RasContext>({
  // data: undefined,
  // setUser: undefined,
});

export function useRasContext<T extends RasContext = RasContext>() {
  const rasContext = useContext(RasContextStore) as T;

  return rasContext;
}
